import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { RpcService } from '../../shared/http/rpc.service';

export interface Floor {
  name: string;
  oid: number;
}

@Injectable()
export class FloorService {
  constructor(private rpc: RpcService) {}

  public getFloors(): Observable<Array<Floor>> {
    return this.rpc.makeManagerCall('getFloors').pipe(
      map((floors: any) => {
        return floors.reduce((prev: Array<Floor>, floor: Floor) => {
          return prev.concat([floor]);
        }, []);
      })
    );
  }
}
